"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2460],{

/***/ 52460:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(77058);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _src_components_atoms__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52738);
/* harmony import */ var _src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9465);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85893);









var Footer = function Footer() {
  var _useTranslation = (0,react_i18next__WEBPACK_IMPORTED_MODULE_6__/* .useTranslation */ .$)(),
      t = _useTranslation.t;

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
    className: "".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_3__/* .getClass */ .ll)("footer", true)),
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
      className: "wrapper mx-auto ".concat( false ? 0 :  true ? "py-2" : 0),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
        className: "flex flex-row items-center justify-center",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
          prefetch: false,
          href: "/",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("a", {
            className: "sm:hidden block",
            style: {
              height:  false ? 0 :  true ? 45 : 0
            },
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_src_components_atoms__WEBPACK_IMPORTED_MODULE_2__/* .CImage */ .DW, {
              source: "/images/logo_parkful.png",
              width:  false ? 0 :  true ? 200 : 0,
              height:  false ? 0 :  true ? 45 : 0,
              layout: "fixed",
              alt: "".concat("Parkful", " logo")
            })
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
          prefetch: false,
          href: "/",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("a", {
            className: "sm:block hidden",
            style: {
              height:  false ? 0 :  true ? 70 : 0
            },
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_src_components_atoms__WEBPACK_IMPORTED_MODULE_2__/* .CImage */ .DW, {
              source: "/images/logo_parkful.png",
              width:  false ? 0 :  true ? 220 : 0,
              height:  false ? 0 :  true ? 70 : 0,
              layout: "fixed",
              alt: "".concat("Parkful", " logo")
            })
          })
        })]
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
      className: "border-t ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_3__/* .getClass */ .ll)("border-grayBackground"), " py-2"),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
        className: "wrapper mx-auto",
        style: {
          paddingLeft: 20,
          paddingRight: 20
        },
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
          className: "flex md:flex-row flex-col-reverse py-2 items-center justify-between",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
            className: "flex-1 flex flex-row md:my-0 my-4 items-center sm:order-1 order-3",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
              className: "text-xs font-regular ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_3__/* .getClass */ .ll)("text-gray2-white", true), " px-4"),
              children: t("key_web_copyright")
            })
          }),  false && /*#__PURE__*/0,  false && /*#__PURE__*/0,  false && /*#__PURE__*/0,  false && /*#__PURE__*/0,  true && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
            className: "flex flex-1 justify-center sm:order-2 order-3",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
              className: "flex flex-row items-center",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
                className: "px-1",
                style: {
                  height: 18
                },
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("a", {
                  href: "https://www.facebook.com/parkful.co",
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_4___default()), {
                    src: "/icons/ic_facebook_circle.svg",
                    width: 18,
                    height: 18,
                    alt: "facebook"
                  })
                })
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
                className: "px-1",
                style: {
                  height: 18
                },
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("a", {
                  href: "https://www.instagram.com/parkful_co",
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_4___default()), {
                    src: "/icons/ic_instagram_circle.svg",
                    width: 19,
                    height: 18,
                    alt: "instagram"
                  })
                })
              })]
            })
          }),  false && /*#__PURE__*/0,  false && /*#__PURE__*/0,  false && /*#__PURE__*/0,  false && /*#__PURE__*/0,  false && /*#__PURE__*/0,  false && /*#__PURE__*/0,  false && /*#__PURE__*/0, /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
            className: "flex-1 flex flex-row items-center justify-end order-2",
            children: [ false && /*#__PURE__*/0, /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
              prefetch: false,
              href: "/cookie-policy/",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("a", {
                className: "text-xs md:px-4 px-1 font-regular ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_3__/* .getClass */ .ll)("text-gray2-white", true)),
                children: t("key_web_cookies")
              })
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
              prefetch: false,
              href: "/legal/",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("a", {
                className: "text-xs md:px-4 px-1 font-regular ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_3__/* .getClass */ .ll)("text-gray2-white", true)),
                children: t("key_web_legal")
              })
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
              prefetch: false,
              href: "/sitemap.xml/",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("a", {
                className: "text-xs md:px-4 px-1 font-regular ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_3__/* .getClass */ .ll)("text-gray2-white", true)),
                children: t("key_web_sitemap")
              })
            })]
          })]
        })
      })
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (Footer);

/***/ })

}]);